import { Component, Input, OnInit } from '@angular/core';
import { has as hasLicense } from '@onviobr/services/licenses';
import { has as hasFrp} from '@onviobr/services/permission';
import { HttpClient } from '@angular/common/http';
import { getBindings, IAuthenticatedSessionBindings, getUserJwtToken } from '@onviobr/services/session';

export interface Application {
	name: string;
	license: string | Array<string>;
	frp: string | Array<string>;
	display: boolean;
	getUrl: any;
	loader?: boolean;
}

@Component({
	selector: 'app-other-applications-widget',
	templateUrl: './other-applications-widget.component.html',
	styleUrls: ['./other-applications-widget.component.css']
})
export class OtherApplicationsWidgetComponent implements OnInit {

	@Input() isUsingLatestSaffron = false ;

	applications: Application[] = [];
	filteredApplications: Application[] = [];
	bindings: IAuthenticatedSessionBindings;
	busyLoader = false;
	hasLicense = hasLicense;
	hasFrp = hasFrp;
	getBindings = getBindings;
	getUserJwtToken = getUserJwtToken;

	constructor(private http: HttpClient
	) {
		this.getK1AnalyzerUrl = this.getK1AnalyzerUrl.bind(this);
	}

	ngOnInit() {
		this.setProducts();
		this.loadBindings();
	}

	async loadBindings() {
		this.bindings = await this.getBindings();
	}

	async checkLicense(license: string | Array<string>): Promise<boolean> {
		if (license === null) {
			return Promise.resolve(true);
		}
		return await this.hasLicense(license);
	}

	async checkFrp(frp: string | Array<string>): Promise<boolean> {
		if (frp === null) {
			return Promise.resolve(true);
		}
		return await this.hasFrp(frp);
	}

	async setProducts() {
		this.applications.push(
			...[{
				name: this.isUsingLatestSaffron ? 'Onvio.Dashboard.MyApplications.LaunchKAnalyser': 'K-1 Analyzer',
				license: null,
				frp: 'Applications.K1Analyzer',
				display: false,
				getUrl: this.getK1AnalyzerUrl,
				loader:false
			},{
				name: this.isUsingLatestSaffron ? 'Onvio.Dashboard.MyApplications.LaunchUltraETax' : 'UltraTax E-file',
				license: 'UltraTaxCS.UTPLicense',
				frp: null,
				display: false,
				getUrl: this.getultraTaxEfileUrl,
				loader: false
			}]
		);
		await this.checkPermissions();
		this.filteredApplications = this.applications.filter(a => a.display);
	}

	async checkPermissions() {
		for (const app of this.applications) {
			app.display =
				await Promise.all([this.checkFrp(app.frp), this.checkLicense(app.license)])
					.then(res => res[0] && res[1])
					.catch(() => false);

		}
	}

	openNewTab(url) {
		window.open(url, '_blank');
	}

	async getK1AnalyzerUrl() {
		const k1Url  = this.bindings.RoutingTable.AuthenticationAggregatorServices + '/v1/external-login/k1-analyzer';
		const contactId = this.bindings.ApplicationConfiguration.ContactId;
		const firmId = this.bindings.ApplicationConfiguration.EmsFirmId;
		const K1AnalyzerIndex = this.applications.findIndex(app => (app.name === 'Onvio.Dashboard.MyApplications.LaunchKAnalyser'
			|| app.name === 'K-1 Analyzer'));
		try {
			this.applications[K1AnalyzerIndex].loader = true;
			const jwtResponse = await this.getUserJwtToken(contactId);
			const jwt = (jwtResponse as any).token;
			const payload = { emsFirmId: firmId };
			const resp = await this.http.post<any>(k1Url, payload,
				{
					headers: {
						Authorization: `Bearer ${jwt}`,
					},
					observe: 'response'
				}
			).toPromise();
			this.applications[K1AnalyzerIndex].loader = false;
			this.openNewTab((resp as any).headers.get('location'));
		} catch {
			this.applications[K1AnalyzerIndex].loader = false;
		}
	}

	async getultraTaxEfileUrl() {
		const ultrataxEfileUrl = 'https://www.ultratax.com/#e-file';
		window.open(ultrataxEfileUrl, '_blank');
	}
}
